import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../common/loader";
import {
  capitalizeFirstLetter,
  formateDate,
  formateDateWithMonth,
  getFormatedTime,
  handleServerValidations,
} from "../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
// import $ from "jquery";
import Breadcrums from "../../common/breadcrumbs";
import {
  subscribeForPremium,
  subscriptionHistoryList,
  unsubscribeFromPremium,
  userDetails,
  getChilds,
} from "../../services/user.service";
import Swal from "sweetalert2";
import {
  SUBSCRIPTION_NAMES,
  SUBSCRIPTION_PRODUCT_IDS,
  SWAL_SETTINGS,
} from "../../../../utils/Constants";

const UserView = (props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const params = useParams();
  // const [query] = useSearchParams();
  const [showdefault, setShowDefault] = useState({});
  const [statsupdate, setStatusUpdate] = useState("false");
  const [activeTab, setActiveTab] = useState("details");
  const [subscriptionList, setSubscriptionList] = useState([]);
  const [childList, setChildList] = useState([]);
  const [childListLoading, setChildListLoading] = useState(false);

  const breadcrumbs = [
    { title: t("link_dashboard"), url: "/admin/dashboard" },
    {
      title: t("User"),
      url: "/admin/user-management/user/list/1",
    },
    { title: t("View"), url: "" },
  ];

  useEffect(() => {
    userDetails(params.id)
      .then((response) => {
        // console.log("View response-", response);
        setShowDefault(response && response.data ? response.data : []);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, [params.id, statsupdate]);

  const handleSubscriptionHistory = () => {
    subscriptionHistoryList(params.id)
      .then((response) => {
        setSubscriptionList(response?.data?.list);
      })
      .catch((err) => {
        console.log("Err===>", err);
      });
  };

  const handleChildDetails = () => {
    setChildListLoading(true);
    getChilds(params.id)
      .then((response) => {
        setChildList(response?.data || []);
      })
      .catch((err) => {
        console.log("Err===>", err);
      })
      .finally(() => {
        setChildListLoading(false);
      });
  };

  const SubscribePremiumPlan = (o_id, plan_type) => {
    Swal.fire({
      customClass: "swal-wide",
      title: t(
        `Are you sure you want to provide this user ${SUBSCRIPTION_NAMES[plan_type]} subscription ?`,
      ),
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: t("btn_cancel"),
      confirmButtonColor: "#403fad",
      cancelButtonColor: "#f1388b",
      confirmButtonText: t("btn_yes"),
    }).then((result) => {
      if (result.isConfirmed) {
        subscribeForPremium({ o_id: o_id, plan_type: plan_type })
          .then((response) => {
            if (response.success) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });
              setStatusUpdate(!statsupdate);
            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            console.log("error===>");
          });
      }
    });
  };
  const UnsubscribePremiumPlan = (o_id) => {
    Swal.fire({
      customClass: "swal-wide",
      title: t(
        `Are you sure you want to unsubscribe this user from the premium plan?`,
      ),
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: t("btn_cancel"),
      confirmButtonColor: "#403fad",
      cancelButtonColor: "#f1388b",
      confirmButtonText: t("btn_yes"),
    }).then((result) => {
      if (result.isConfirmed) {
        unsubscribeFromPremium({ o_id: o_id })
          .then((response) => {
            if (response.success) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });
              setStatusUpdate(!statsupdate);
            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            console.log("error===>");
          });
      }
    });
  };

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <ul className="nav nav-tabs mb-2 mt-3 ms-4">
              <li className="nav-item">
                <button
                  className={`nav-link ${activeTab === "details" ? "active" : ""}`}
                  onClick={() => setActiveTab("details")}
                >
                  {t("View Details")}
                </button>
              </li>
              <li className="nav-item">
                <button
                  className={`nav-link ${activeTab === "childDetails" ? "active" : ""}`}
                  onClick={() => {
                    setActiveTab("childDetails");
                    handleChildDetails();
                  }}
                >
                  {t("Child List")}
                </button>
              </li>
            </ul>

            <div className="card-body">
              {showdefault && Object.keys(showdefault).length > 0 ? (
                <div className="row">
                  {activeTab === "details" && (
                    <div className="col-lg-12 form-group">
                      <table
                        id="simple-table"
                        className="table table-bordered table-hover"
                      >
                        <tbody>
                          {/* Profile Info Table (excluding subscription) */}
                          <tr>
                            <th>{t("Image")}</th>
                            <td>
                              <img
                                src={showdefault?.profile_image || "N/A"}
                                alt="profile"
                                style={{ height: "100px" }}
                              />
                            </td>
                          </tr>
                          <tr>
                            <th>{t("Name")}</th>
                            <td className="text-capitalize">
                              {showdefault?.name || "N/A"}
                            </td>
                          </tr>
                          <tr>
                            <th>{t("label_phone_number")}</th>
                            <td>{showdefault?.phone_number || "N/A"}</td>
                          </tr>
                          <tr>
                            <th>{t("lable_email")}</th>
                            <td>{showdefault?.email || "N/A"}</td>
                          </tr>
                          <tr>
                            <th>{t("list_heading_created_date")}</th>
                            <td>
                              {showdefault?.createdAt
                                ? formateDate(showdefault.createdAt)
                                : "N/A"}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  )}
                  {/* Separate Subscription Plan Section */}
                  {activeTab === "subscriptionPlan" && (
                    <div className="col-lg-12">
                      <div className="card shadow-sm border">
                        <div className="card-body">
                          <h5 className="mb-3">{t("Subscription Plan")}</h5>

                          {/* Extract values for clarity */}
                          {(() => {
                            const isFreePlan =
                              showdefault?.subscription_plan === "free";
                            const expiryDate = new Date(
                              showdefault?.subscription_expiry,
                            );
                            const isExpired =
                              !showdefault?.subscription_expiry ||
                              expiryDate <= new Date();
                            const isPremium =
                              showdefault?.subscription_plan === "premium";
                            const isPremiumAndActive = isPremium && !isExpired;

                            if (isPremiumAndActive) {
                              return (
                                <>
                                  <p>
                                    <strong>{t("Current Plan")}:</strong>{" "}
                                    {capitalizeFirstLetter(
                                      showdefault.subscription_plan,
                                    )}
                                  </p>
                                  <p>
                                    <strong>{t("Plan Type")}:</strong>{" "}
                                    {
                                      SUBSCRIPTION_NAMES[
                                        showdefault.subscription_type
                                      ]
                                    }
                                  </p>
                                  <p>
                                    <strong>{t("Expiry Date")}:</strong>{" "}
                                    {expiryDate.toLocaleDateString()}
                                  </p>
                                  <button
                                    className="btn btn-danger mt-2"
                                    onClick={() =>
                                      UnsubscribePremiumPlan(showdefault._id)
                                    }
                                  >
                                    {t("Unsubscribe from Premium")}
                                  </button>
                                </>
                              );
                            } else {
                              return (
                                <>
                                  <p className="mb-2">
                                    {t(
                                      "No active subscription. Choose a plan below:",
                                    )}
                                  </p>
                                  <select
                                    className="form-select w-auto d-inline-block me-2"
                                    onChange={(e) => {
                                      const newPlan = e.target.value;
                                      if (!newPlan) return;
                                      console.log("Selected plan:", newPlan);
                                      SubscribePremiumPlan(
                                        showdefault._id,
                                        newPlan,
                                      );
                                    }}
                                    defaultValue=""
                                  >
                                    <option value="" disabled>
                                      {" "}
                                      {t("Select a plan")}{" "}
                                    </option>
                                    <option
                                      value={
                                        SUBSCRIPTION_PRODUCT_IDS.ONE_MONTH_SUBSCRIPTION
                                      }
                                    >
                                      {t("Monthly")}
                                    </option>
                                    <option
                                      value={
                                        SUBSCRIPTION_PRODUCT_IDS.THREE_MONTH_SUBSCRIPTION
                                      }
                                    >
                                      {t("Quarterly")}
                                    </option>
                                    <option
                                      value={
                                        SUBSCRIPTION_PRODUCT_IDS.TWELVE_MONTH_SUBSCRIPTION
                                      }
                                    >
                                      {t("Yearly")}
                                    </option>
                                  </select>
                                </>
                              );
                            }
                          })()}
                        </div>
                      </div>
                    </div>
                  )}
                  {/* Child Details */}
                  {activeTab === "childDetails" && (
                    <div className="col-lg-12">
                      <h5>{t("Child List")}</h5>
                      {childListLoading ? (
                        <Loader />
                      ) : childList?.length > 0 ? (
                        <table className="table table-bordered table-hover">
                          <thead>
                            <tr>
                              <th>{t("Nick Name")}</th>
                              <th>{t("Age Group")}</th>
                              <th>{t("Created Date")}</th>
                              <th>{t("Gender")}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {childList.map((child, index) => (
                              <tr key={index}>
                                <td className="text-capitalize">
                                  {child?.nick_name || "N/A"}
                                </td>
                                <td>{child?.age_group || "N/A"}</td>
                                <td>
                                  {child?.createdAt
                                    ? formateDate(child.createdAt)
                                    : "N/A"}
                                </td>
                                <td className="text-capitalize">
                                  {child?.gender || "N/A"}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      ) : (
                        <div className="text-center p-3">
                          <p>{t("No children found")}</p>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              ) : (
                <Loader />
              )}
            </div>

            {/* Back Button */}
            <div className="mt-2 back-button">
              <button
                className="btn ripple btn-dark"
                type="button"
                onClick={() => navigate(-1)}
              >
                <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                {t("btn_back")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserView;
